<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        id="carregaDados"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando Dados...
      </div>
      <div
        v-else-if="error"
        id="errorPedidoDia"
        class="text-center"
        :style="styleObject"
      >
        {{ error }}
      </div>
      <canvas
        id="myChart11"
        width="40"
        height="12"
      />
      <div
        v-if="exibirLegenda"
        id="legendaPedidoDiaADia"
        class="text-center px-3"
      >
        <v-row
          align="center"
          class="ma-0"
          no-gutters
        >
          <v-col
            md="6"
            offset-md="3"
          >
            <v-row>
              <div
                v-for="status in statusDiaaDia"
                :key="status.statusExibicao"
              >
                <v-avatar
                  class="mr-1"
                  :color="status.corExibicao"
                  size="12"
                />
                <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
      <template>
        <v-dialog
          v-model="dialog.visible"
          transition="dialog-bottom-transition"
          persistent
          max-width="1000px"
          content-class="custom-dialog-content"
          @keydown.esc="dialog.visible = false"
        >
          <v-card>
            <v-card-title>
              <v-spacer />
              <v-icon
                aria-label="Close"
                @click="dialog.visible = false, excluirPagina = true"
              >
                mdi-close
              </v-icon>
            </v-card-title>
            <v-card-text
              class="text-center"
              :style="styleCancelado"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="9"
                  md="9"
                  lg="9"
                  class="text-center"
                >
                  <h4>{{ dialog.message }} - {{ dialog.valor }}</h4>
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                  md="3"
                  lg="3"
                >
                  <v-btn
                    small
                    :color="corPrimaria"
                    dark
                    :loading="imprimindo"
                    @click="imprimirDetalhe(dialog.message)"
                  >
                    <v-icon>
                      mdi-printer
                    </v-icon>
                    Imprimir
                    <template v-slot:loader>
                      <span>Imprimindo...</span>
                    </template>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text
              class="pb-3 pt-6 text-center"
              style="white-space: pre-line"
            >
              <div
                id="idTable"
                style="overflow-x: auto;"
              >
                <table
                  style="width: 100%; color: black; border-collapse: collapse;"
                  class="elevation-1"
                  mobile-breakpoint="0"
                >
                  <thead>
                    <tr>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 15%;"
                        class="black--text title"
                      >
                        Num. Pedido
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 45%;"
                        class="black--text title"
                      >
                        Cliente
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 20%;"
                        class="black--text title"
                      >
                        Vendedor
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 10%;"
                        class="black--text title"
                      >
                        Data
                      </th>
                      <th
                        id="dadoMovimentacaoHeader"
                        style="text-align: center; width: 10%;"
                        class="black--text title"
                      >
                        Valor
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in clients"
                      :key="item.id"
                    >
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                      >
                        {{ item.pedido }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ item.cliente }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: left;"
                      >
                        {{ item.vendedor }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: center;"
                      >
                        {{ item.periodo }}
                      </td>
                      <td
                        id="dadoMovimentacao"
                        style="text-align: right;"
                        :style="styleCancelado"
                      >
                        {{ item.valor }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
  import Chart from 'chart.js'
  import Pedidos from '../../../../services/pedidos'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardPedidosDiaADia',
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
    },

    data: () => ({
      corPrimaria: localStorage.corPrimaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleCancelado: {
        color: '#D32F2F',
      },
      colors: [],
      myChart: {},
      select: [],
      receita: [],
      rede: [],
      categoria: [],
      promotor: [],
      vendedor: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      text: null,
      montarGrafico: true,
      datasets: [],
      statusDiaaDia: [],
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      diaFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      loading: false,
      error: null,
      exibirLegenda: false,
      headersClients: [
        { text: 'Num. Pedido', value: 'pedido', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Data', value: 'periodo', align: 'left', class: 'black--text title' },
        { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
      ],
      clients: [],
      dialog: {
        visible: false,
        message: '',
        valor: 0,
      },
      imprimindo: false,
      loadingPrint: false,
    }),

    created () {
      eventEmit.$on('update-pedidos', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-pedidos', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, receita, rede, categoria, promotor, vendedor) {
        this.primeiroDia = primeiroDia
        this.diaFinal = dataFinal
        this.select = select
        this.receita = receita
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.vendedor = vendedor

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.datasets = []

          this.myChart.destroy()
        }

        await Pedidos.showPedidosDiaADia(this.primeiroDia, this.diaFinal, this.select, this.receita, localStorage.tokencontrato, this.rede, this.categoria, this.promotor, this.vendedor).then(resposta => {
          if (resposta.data.status) {
            this.error = null
            const ctx = document.getElementById('myChart11').getContext('2d')

            this.statusDiaaDia = resposta.data.statusPedidos

            for (var i = 0; i < resposta.data.dadosPedidos.length; i++) {
              const dados = {
                label: resposta.data.dadosPedidos[i].status,
                backgroundColor: resposta.data.dadosPedidos[i].cor,
                order: i + 1,
                data: resposta.data.dadosPedidos[i].pedidos,
              }

              this.datasets.push(dados)
            }

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.data,
                datasets: this.datasets,
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                    max: 1000,
                    type: 'logarithmic',
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    max: 1000,
                    type: 'logarithmic',
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                events: ['click'],
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                      this.exibirPedidos(resposta.data.dia[tooltipItem.index], tooltipItem.xLabel, valor)

                      return valor
                    },
                    title: (tooltipItem, data) => {
                      var i = tooltipItem[0].datasetIndex

                      tooltipItem[0].xLabel = data.datasets[i].label

                      return tooltipItem[0].xLabel
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há pedidos em abertos para o período selecionado.') {
            this.error = resposta.data.msg

            this.text = 'Não há pedidos em abertos para o período selecionado.'

            this.showSnackbar('error', 3000, resposta.data.msg)

            if (this.myChart.data) {
              this.datasets = []

              this.myChart.destroy()
            }
          } else if (resposta.data.msg === 'Não há dados para exibição do gráfico.') {
            this.error = resposta.data.msg

            this.text = 'Não há dados para exibição do gráfico.'

            this.showSnackbar('error', 3000, resposta.data.msg)

            if (this.myChart.data) {
              this.myChart.destroy()
            }
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },

      exibirPedidos (dia, status, valor) {
        this.clients = []

        var i = 0

        for (i in this.statusDiaaDia) {
          if (status === this.statusDiaaDia[i].statusExibicao) {
            this.styleCancelado.color = this.statusDiaaDia[i].corExibicao
          }
        }

        Pedidos.showEnableDadosPedidos(dia, status, this.select, this.receita, localStorage.tokencontrato, this.rede, this.categoria, this.promotor, this.vendedor).then(resposta => {
          if (resposta.data.status) {
            this.clients = resposta.data.clientes.map((item) => {
              var listaDados = ({
                pedido: item.pedido,
                cliente: item.cliente,
                vendedor: item.vendedor,
                periodo: item.periodo,
                valor: item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
              })

              return listaDados
            })

            this.showDialog(status, valor)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      showDialog (message, valor) {
        this.dialog.visible = true
        this.dialog.message = message
        this.dialog.valor = valor
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },

      async imprimirDetalhe (status) {
        try {
          this.loadingPrint = true
          this.imprimindo = true

          await this.executarImpressaoDetalhe(status)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        } finally {
          this.loadingPrint = false
          this.imprimindo = false
        }
      },

      async executarImpressaoDetalhe (status) {
        return new Promise(resolve => {
          setTimeout(() => {
            this.printDetalhe(10, status)

            resolve()
          }, 3000)
        })
      },

      async printDetalhe (posYFiltros, status) {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map((cell, index) => {
                const isFaturamentoColumn = index === 0 || index === 4
                return {
                  content: cell,
                  styles: {
                    fontSize: 8,
                    textColor: [0, 0, 0],
                    halign: isFaturamentoColumn ? 'right' : 'left',
                  },
                }
              })),
              startY: posY,
              styles: { fontSize: 10 },
            })

            posY = 20

            return posY
          }

          const titleTableMovimentacao = 'Detalhe Pedidos ' + status

          const tableTableMovimentacao = this.clients.map(item => [item.pedido, item.cliente, item.vendedor, item.periodo, item.valor])

          await addTable(tableTableMovimentacao, this.headersClients, titleTableMovimentacao, posYFiltros, 8)

          // Salvar o PDF
          pdf.save('detalhe_pedidos.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
        }
      },
    },
  }
</script>

<style scoped>
  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #myChart11 {
      margin: 0rem 0 0 0;
      /* width: 434px !important;
      height: 130px !important; */
    }

    #legendaPedidoDiaADia {
      font-size: 10px;
      margin: 1rem 0 0 8rem;
      display: grid;
    }

    #errorPedidoDia {
      margin: 16rem 0 0 0;
    }

    #idTable {
      max-height: 450px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #legendaPedidoDiaADia {
      font-size: 11px;
      margin: 1.5rem 0 3rem 4rem;
      display: grid;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 445px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }
</style>

<style lang="sass">
  #myChart11
    // width: 100vh
    // height: 100vh

  #legendaPedidoDiaADia
    margin: 0 0 1rem 0
    width: auto
    height: auto

  #statusDiaAdia
    margin: -1rem 0 0.2rem 2rem

  #textTable
    font-weight: bold
</style>
